module.exports = __webpack_public_path__ + "static/img/Claire.85a4825.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Claire.jpg
// module id = rTfY
// module chunks = 1